import { store } from "@/redux/store";
import { isSystemUser } from "@/utils/orgTypeUtils";
import DeviceAdminRoute from "./_deviceAdminRoute";

interface DeviceHomePageData {
  [key: string]: string | number | undefined;
}

interface DeviceHomeUpdateData {
  id?: string | number;
  tabActive?: string;
  type?: string;
  org?: string | number;
  [key: string]: string | number | undefined;
}

interface DeviceHomeCreateData {
  orgId?: string | number;
}

interface DeviceHomeRoute {
  page: string;
  updatePage: string;
  createPage: string;
  getPage: (data?: DeviceHomePageData) => string;
  getUpdatePage: (data: DeviceHomeUpdateData) => string;
  getCreatePage: (data?: DeviceHomeCreateData) => string;
}

const _deviceHomeRoute: DeviceHomeRoute = {
  page: "/tracked_assets",
  updatePage: "/tracked_assets_update",
  createPage: "",
  getPage: (data) => {
    return `/tracked_assets`;
  },
  getUpdatePage: (data) => {
    // SYSTEM users have no "home" menu — /tracked_assets_update would land them
    // on an empty sidebar. Route them to the admin device page instead (STIC-15212).
    // It's the same DeviceDetailPage; only the default tab differs, so we drop the
    // home-specific tabActive and let the admin page open its default tab.
    if (isSystemUser(store.getState().user)) {
      const adminData = { ...data };
      delete adminData.tabActive;
      return DeviceAdminRoute.getUpdatePage(adminData);
    }
    const queryString = new URLSearchParams(
      data as Record<string, string>
    ).toString();
    return `/tracked_assets_update?${queryString}`;
  },
  getCreatePage: (data) => {
    if (data?.orgId) return `/tracked_assets_update?org=${data.orgId}`;
    return `/tracked_assets_update?`;
  },
};

export default _deviceHomeRoute;
